/**
 * @flow
 * @relayHash 97378bc558326225a8dab9e1ff073b87
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateEventInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
};
export type ShowEvent_UpdateEventMutationVariables = {|
  input: UpdateEventInput
|};
export type ShowEvent_UpdateEventMutationResponse = {|
  +updateEvent: ?{|
    +event: ?{|
      +title: ?string
    |}
  |}
|};
export type ShowEvent_UpdateEventMutation = {|
  variables: ShowEvent_UpdateEventMutationVariables,
  response: ShowEvent_UpdateEventMutationResponse,
|};
*/


/*
mutation ShowEvent_UpdateEventMutation(
  $input: UpdateEventInput!
) {
  updateEvent(input: $input) {
    event {
      title
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEventInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateEventInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ShowEvent_UpdateEventMutation",
  "id": null,
  "text": "mutation ShowEvent_UpdateEventMutation(\n  $input: UpdateEventInput!\n) {\n  updateEvent(input: $input) {\n    event {\n      title\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShowEvent_UpdateEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEvent",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEventPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [
              v2
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShowEvent_UpdateEventMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEvent",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEventPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a61bcdf9683c48ef71a414f251d89b33';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/__generated__/ShowEvent_UpdateEventMutation.graphql.js